/**
 * Available sort columns for the book library
 */
export const SORT_COLUMNS = ["title", "author", "featuredDate", "rating", "createdAt"] as const;

/**
 * Type for sort column values
 */
export type SortColumn = (typeof SORT_COLUMNS)[number];

/**
 * Display labels for sort columns
 */
export const SORT_COLUMN_LABELS: Record<SortColumn, string> = {
    author: "Author",
    createdAt: "Date Added",
    featuredDate: "Featured Date",
    rating: "Rating",
    title: "Title",
} as const;
